module.exports = __webpack_public_path__ + "static/media/depreciation.016e3906.svg";